<template>
  <div class="mobile-content">
    mobile
    <div
      v-if="showParticipateBtn || 1"
      :class="cssTheme"
      class="mobile-grid-wrapper"
    >
      <div class="m-3 text-center">
        <Btn :label="labelParticipateBtn" @click.native="onParticipate" />
      </div>
    </div>
    <div
      v-if="isHiddenPoll"
      :class="aligmentCss"
      class="d-flex text-weight-semi-bold"
    >
      <div
        class="info-content text-size-14 flex-row mobile-info-wrapper"
        :class="cssTheme"
      >
        <div class="mx-1">
          <font-awesome-icon class="mx-1" :icon="['fas', 'info-circle']" />
          {{ msgHiddenPoll }}
        </div>
      </div>
    </div>

    <div ref="responses" :class="cssTheme" class="mobile-grid-wrapper">
      <div class="col">
        <navigation-tabs
          v-if="0 && !isHiddenParticipantMode"
          :navItems="navItems"
          v-model="currentTabComponent"
          class="mobile-nav grid-header"
          :class="cssTheme"
        />

        <Header :textColor="textColor">
          <div class="d-flex justify-content-between w-100">
            <div class="d-flex align-items-center text-size-18">
              <font-awesome-icon class="mr-1" :icon="['fas', 'check']" />
              {{ responsesHeadline }}
              <span
                v-if="isOwner"
                v-on:click="enterNewParticipant()"
                class="text-primary ml-2"
              >
                <font-awesome-icon :icon="['fas', 'plus-circle']" />
              </span>
            </div>

          </div>
        </Header>

        <div
          v-if="pollInfoMessage"
          :class="aligmentCss"
          class="d-flex mx-0 text-weight-semi-bold"
        >
          <div
            :style="gridTheme"
            :class="[pollInfoMessage.class, , cssTheme]"
            class="legend-content text-size-14 flex-row"
          >
            <div class="mx-1">
              <font-awesome-icon class="mx-1" :icon="pollInfoMessage.icon" />
              {{ pollInfoMessage.text }}
            </div>
          </div>
        </div>
      </div>

      <div v-if="showEventCounts" :class="cssTheme" class="text-grey">
        <div
          class="km-event-status text-white justify-content-between align-items-start text-size-16 text-weight-semi-bold pa-3 bg-dark-grey border-2px"
        >
          <div class="event-status-colum">
            <div class="event-status-title">
              {{ $t('event.statusInvitations') }}
            </div>
            <div class="event-status-value">
              {{ openEventInvitations }}
            </div>
          </div>

          <div class="event-status-colum">
            <div class="event-status-title">
              {{ $t('event.statusConfirmations') }}
            </div>
            <div class="event-status-value text-success text-center">
              {{ confirmations - guests }}
              <span class="ml-1" v-if="poll.options.limitedVotesPerEvent"
                >(+{{ guests }})</span
              >
            </div>
          </div>
          <div class="event-status-colum">
            <div class="event-status-title">
              {{ $t('event.statusDeclines') }}
            </div>
            <div class="event-status-value text-danger text-center">
              {{ declines }}
            </div>
          </div>
        </div>
      </div>

      <component
        @startEditParticipant="startEditParticipant"
        @next="onNext"
        @previous="onPrevious"
        :participants="participants"
        :isDarkMode="isDarkMode"
        v-bind:is="currentTabComponent"
      ></component>
    </div>

    <div
      v-if="showTasks"
      id="tasks"
      ref="tasks"
      :class="cssTheme"
      class="mobile-task-wrapper"
    >
      <renderTasks :isDarkMode="isDarkMode"></renderTasks>
    </div>

    <div
      v-if="showComments"
      ref="comments"
      :class="cssTheme"
      class="mobile-grid-wrapper"
    >
      <renderComments
        :isDarkMode="isDarkMode"
        :allowComments="!true"
      ></renderComments>
    </div>

    <div class="mobile-bottom-space"></div>

    <a v-if="0" @click="enterNewParticipant" href="#" class="float">
      <font-awesome-icon class="my-float" :icon="['fal', 'plus']" />
    </a>

    <NavigationButtons
      :displayTask="showTasks"
      :displayComment="showComments"
      :displayNavigationButtons="false"
      @whenClicked="startScrollWhenClicked"
    >
    </NavigationButtons>

    <ModalParticipant
      ref="newParticipantModal"
      :user="user"
      :invitation="invitation"
      :edit-mode="modalEditMode"
      :edit-participant="editParticipant"
      @save="onSaveModal"
      @cancel="stopEditParticipant"
    >
    </ModalParticipant>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import renderParticipants from './RenderMobileEventParticipants';
import renderInvitations from './RenderMobileInvitations';
import renderComments from './RenderMobileComments';
import renderTasks from './RenderMobileTasks';
import RenderDataMobile from '@/components/Rendering/RenderDataMobile.vue';
import NavigationTabs from '@/components/UI/NavigationTabs';
import Header from '@/components/Rendering/RenderMobileHeader.vue';
import NavigationButtons from './NavigationButtons.vue';

import ModalParticipant from '@/components/UI/ModalParticipant';
import RenderHiddenModeParticipantMobile from '@/components/Rendering/RenderHiddenModeParticipantMobile';

import { renderMixin } from '../mixins/RenderMixins';
import { modalParticipantMixins } from '../mixins/ModalParticipantMixins';
import { eventMixin } from '../mixins/EventMixins';
import { pollMixin } from '../mixins/PollMixins.js';
import { deviceMixin } from '../mixins/DeviceMixins';
import { gridMixin } from '../mixins/GridMixins';
import { themeMixin } from '../mixins/ThemeMixins';

import sortParticipants from '@/shared/sortParticipants';

export default {
  name: 'RendererEventMobile',
  mixins: [
    renderMixin,
    themeMixin,
    deviceMixin,
    gridMixin,
    modalParticipantMixins,
    eventMixin,
    pollMixin,
  ],
  data() {
    return {
      curParticipant: 0,
      currentTab: 0,
      currentTabComponent: 'render-participants',
      modalEditMode: false,
      editParticipant: null,
    };
  },

  components: {
    renderParticipants,
    renderComments,
    renderTasks,
    renderInvitations,
    RenderDataMobile,
    ModalParticipant,
    NavigationTabs,
    Header,
    RenderHiddenModeParticipantMobile,
    NavigationButtons,
  },

  watch: {
    'poll.participants': {
      deep: true,
      handler() {
        this.currentParticipant = this.getCurrentParticipant();
      },
    },
  },

  methods: {
    onNext() {
      this.curParticipant++;
    },

    onPrevious() {
      this.curParticipant--;
    },

    startEditParticipant() {
      console.log('startEditParticipant was actibvated');
      if (!this.isEditable(this.participant)) {
        console.log('current participant not editable');
        return;
      }

      this.editParticipant = this.participant;
      this.modalEditMode = true;
      this.$refs.newParticipantModal.openModal();
    },
    startScrollWhenClicked($event) {
      this.goto($event);
    },
  },
  computed: {
    ...mapState({
      curInvitation: (state) => state.curInvitation,
      poll: (state) => state.poll.poll,
      userId: (state) => state.Login.userId,
      ownerId: (state) => state.poll.poll.user.id,
      keyUserId: (state) => state.keyUserId,
    }),

    ...mapGetters([
      'user',
      'isOwner',
      'isPollEditable',
      'isPublicLink',
      'isAuthenticated',
      'isAdminLink',
    ]),

    isParticipantsMode() {
      if (this.currentTabComponent === 'render-participants') return true;
      return false;
    },

    // showStatistic() {
    //   if (this.isHiddenParticipantMode) return false;
    //   if (this.isParticipantsMode) return true;
    //   return false;
    // },

    isDarkMode() {
      if (this.poll.options.darkMode) return true;
      return false;
    },

    cssTheme() {
      var isFirefox = typeof InstallTrigger !== 'undefined';
      console.log({ isFirefox });
      if (this.isDarkMode) {
        if (isFirefox) {
          return 'dark-mode dark-mode-bg-ff';
        }
        return 'dark-mode dark-mode-bg';
      }
      if (isFirefox) {
        return 'light-mode light-mode-bg-ff';
      }
      return 'light-mode light-mode-bg';
    },

    navItems() {
      let items = [];
      const itemParticipants = {
        code: 'render-participants',
        label: this.participantCount + '<br/>' + this.$t('polls.navInvites'),
      };
      items.push(itemParticipants);

      if (this.poll.options.allowComments) {
        const itemComments = {
          code: 'render-comments',
          label: this.commentsCount + '<br/>' + this.$t('polls.navComments'),
        };
        items.push(itemComments);
      }

      return items;
    },

    // participants() {
    //   console.log('participants: ', this.poll.participants);
    //   let participants = this.poll.participants;
    //   return participants;
    // },

    // participantCount() {
    //   return this.participants.length;
    // },

    participant() {
      return this.participants[this.curParticipant];
    },
    participantName() {
      return this.participants[this.curParticipant].name;
    },
  },

  mounted() {
    console.log('(RenderEventMobile) cur invitation:', this.curInvitation);
    const viewportContent = 'width=device-width initial-scale=1.0';
    document
      .querySelector("meta[name='viewport']")
      .setAttribute('content', viewportContent);

    let participants = this.identifyCurrentUser(this.poll.participants);

    // make sure that the current user is on the top of the list
    sortParticipants(participants, this.userId);
    this.$store.commit('updateParticipants', participants);

    const currentParticipant = this.getCurrentParticipant();
    // if current participnat exist the user is logged in or identified by the lastParticipant
    if (currentParticipant) {
      return;
    }

    const doEnterNewParticipant = this.isNewParticipantRequired();
    if (doEnterNewParticipant) {
      this.enterNewParticipant(true);
    }
  },
};
</script>

<style scoped lang="scss">
@import '@/styles/colors.scss';

.km-event-status {
  border-radius: 10px;
  display: flex;
  flex-direction: row;
  margin: 10px;
  margin-bottom: 6px;
  padding: 5px;
  padding-left: 24px;
  padding-right: 24px;
}
</style>
